<template>
    <div class="modal-footer">
        <slot></slot>
        <div class="row flex-grow-1">
            <div class="col-6"><slot name="start"></slot></div>
            <div class="col-6 d-flex justify-content-end"><slot name="end"></slot></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalFooter"
}
</script>

<style scoped>

</style>
